import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSun = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 3.2,
		stroke: "currentColor",
		strokeWidth: 1.2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 1.2V2.6M8 13.4V14.8M14.8 8H13.4M2.6 8H1.2M12.8 3.2 11.8 4.2M4.2 11.8 3.2 12.8M12.8 12.8 11.8 11.8M4.2 4.2 3.2 3.2",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSun;
